@if (isLoadingModeSwitch) {
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <mat-spinner color="accent"></mat-spinner>
  </div>
}
@if (showHeader) {
  <div class="pl-4 pr-4 pt-4">
    <div class="flex flex-col sm:flex-row items-center justify-between mb-2">
      <img src="assets/logo.png" alt="Novo Studio Logo" class="h-10 sm:h-20 mb-4 sm:mb-0 mr-3 cursor-pointer"
        id="novo-studio-logo" (click)="returnHome()">
        <div class="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6">
          <div class="flex items-center">
            <app-language-switcher></app-language-switcher>
          </div>
          @if (shouldShowEnvironment) {
            <div class="text-sm text-gray-500">
              <span class="font-bold">Env:</span>
              <span class="ml-2">{{environment}}</span>
            </div>
          }
          @if (!shouldRestrictMenu && showLibrairie()) {
            <div class="flex items-center cursor-pointer"
              (click)="goToLibrairie()">
              <span class="material-symbols-outlined mr-2">dashboard</span>
              {{ 'LIBRAIRIE' | translate }}
            </div>
          }
          @if (!shouldRestrictMenu && utilisateurService.entiteUtilisateurSelectionnee != null && (isRootMode || utilisateurService.entiteUtilisateurSelectionnee?.roleEntites!.length > 0)) {
            <div
              class="flex items-center cursor-pointer" (click)="goToTableauDeBord()">
              <span class="material-symbols-outlined mr-2">speed</span>
              {{ 'DASHBOARD' | translate }}
            </div>
          }
          @if (!shouldRestrictMenu && canInviteUsers()) {
            <div class="flex items-center cursor-pointer"
              (click)="openInviteDialog()">
              <span class="material-symbols-outlined mr-2">person_add</span>
              {{ 'USERS_MANAGEMENT.INVITE' | translate }}
            </div>
          }
          @if (shouldShowAideEtSupport()) {
            <div class="flex items-center cursor-pointer"
              (click)="goToAideEtSupport()">
              <span class="material-symbols-outlined mr-2">help</span>
              {{ 'AIDE' | translate }}
            </div>
          }
          @if (utilisateurService.entiteUtilisateurSelectionnee != null && shouldShowChangeEntityButton()) {
            <div
              class="flex items-center text-lg font-semibold text-rougeNovo cursor-pointer"
              (click)="goToSelectionEntite()">
              <span class="material-symbols-outlined mr-2">switch_account</span>{{
              utilisateurService.entiteUtilisateurSelectionnee.entiteNom }} @if (!utilisateurService.entiteUtilisateurSelectionnee.estActif && utilisateurService.entiteUtilisateurSelectionnee.entiteId !== EEntite.ROOT_ENTITE_ID) {
              <span
              class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
            }
          </div>
        }
        <div class="flex items-center">
          <div class="menu-container">
            <button type="button" class="flex items-center rounded-md px-3 py-2" (click)="toggleModeMenu()">
              <span class="material-symbols-outlined mr-2">person</span>
              @if (!utilisateurService.selectionEntiteUtilisateur?.modeRootAccessible) {
                <span>
                  {{authService.Name}}
                </span>
              }
              @if (utilisateurService.selectionEntiteUtilisateur?.modeRootAccessible) {
                <span>
                  {{authService.Name}} ({{isRootMode ? 'Root' : 'Non Root'}})
                </span>
              }
              <span class="material-symbols-outlined ml-2">expand_more</span>
            </button>
            @if (showModeMenu) {
              <div
                class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                <div class="py-1">
                  <div class="block px-4 py-2 text-sm cursor-pointer text-gray-900" (click)="goToProfil()">
                    {{ 'MENU_PROFIL_UTILISATEUR' | translate }}
                  </div>
                  @if (utilisateurService.selectionEntiteUtilisateur?.modeRootAccessible && shouldShowChangeEntityButton()) {
                    <div
                      class="block px-4 py-2 text-sm cursor-pointer text-gray-900"
                      (click)="goToSelectionEntite()">
                      {{ 'MENU_CHOIX_ENTITE' | translate }}
                    </div>
                  }
                  @if (utilisateurService.selectionEntiteUtilisateur?.modeRootAccessible) {
                    <div
                      class="block px-4 py-2 text-sm cursor-pointer text-gray-900" (click)="switchMode()">
                      {{ 'MENU_CHOIX_MODE' | translate }} {{isRootMode ? 'Non Root' : 'Root'}}
                    </div>
                  }
                  @if (shouldShowAideEtSupport()) {
                    <div
                      class="block px-4 py-2 text-sm cursor-pointer text-gray-900"
                      (click)="goToAideEtSupport()">
                      {{ 'AIDE_ET_SOUTIEN.TITLE' | translate }}
                    </div>
                  }
                  <div class="block px-4 py-2 text-sm cursor-pointer text-gray-900" (click)="deconnecter()">
                    <a href="SSO_LogoutPage_Uri"></a>{{ 'MENU_DECONNEXION' | translate }}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
<app-message-information></app-message-information>
<router-outlet></router-outlet>